export const environment = {
  production: false,
  buildNo:202609111833,
  version: 'Dev 2.0.1',
  baseUrl: 'https://dev.csmsv2-api.mojosoft.work',
  app: "wfm",
  assetsUrl: 'https://dev.wfm.mojosoft.work/resources',
  userId: 'wfm',
  password: 'wfmdev',
  appKey: "16b849379b809e91ecb3a7357012c5b2"
};
